import MuiStack, { type StackProps } from '@mui/material/Stack';

export type { StackProps };

const Stack = (props: StackProps) => <MuiStack {...props} />;

export default Stack;
